<template>
  <div class="ds-control dsf_teas_meal_application mobile">
    <van-search v-model="searchValue" show-action shape="round" placeholder="搜索" @search="search()" v-if="showSearch">
      <template #action>
        <div @click="onSearch" class="application_filter">
          <i class="iconfont icon-icon_filter"></i>
        </div>
      </template>
    </van-search>
    <div class="aplication_list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" :error.sync="error">
          <DsfMobileTeasCell :titleEllipsis="2" :title="item.reason" class="list_item" v-for="(item,index) in list" :key="index" @click.native="listClick(item,index)">
            <DsfMobileTeasCellItem :label="item.restaurant || '无'" icon="icon-location-hollow"></DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem :label="item.dined_time || '无'" icon="icon-icon-date"></DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem :label="item.category || '无'" icon="icon-icon-cb"></DsfMobileTeasCellItem>
            <div slot="ft">
              <DsfMobileTeasSeal :status="getStatus(item.status_value)" :text="item.status_text"></DsfMobileTeasSeal>
            </div>
          </DsfMobileTeasCell>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>
    <div class="application_zwf" v-if="showBtn"></div>
    <div class="aplication_btn" v-if="showBtn && !isDesign">
      <slot name="btn">
        <div @click="addBtn">新增</div>
      </slot>
    </div>
    <van-popup v-model="showPicker" round position="bottom" get-container="#app">
      <div class="appilcation_picker">
        <div class="picker_tit">
          <div></div>
          <span>筛选条件</span>
          <i class="iconfont icon-guanbi2" @click="showPicker=false"></i>
        </div>
        <div class="picker_type">用餐时间</div>
        <div class="picker_date">
          <div @click="showDate=true">{{startDate ||'开始时间'}}</div>
          <span>-</span>
          <div @click="showDate=true">{{endDate||'结束时间'}}</div>
        </div>
        <div class="picker_type">用餐类别</div>
        <div class="picker_select">
          <div class="select_item" @click="chooseChange(item)" v-for="(item,index) of typeArr" :key="index" :class="[chooseType==item.value?'chooseType':'']">{{item.text}}</div>
        </div>
        <div class="picker_btn">
          <div class="btn_cz" @click="pickerCz">重置</div>
          <div class="btn_qd" @click="pickerSure">确定</div>
        </div>
      </div>
    </van-popup>
    <van-calendar v-model="showDate" type="range" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" get-container="#app" class="list_box_calendar"/>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasMealApplicationList",
  ctrlCaption: "用餐申请列表",
  mixins: [$mixins.control],
  data() {
    return {
      searchValue: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      showPicker: false,
      showDate: false,
      //   筛选条件开始时间
      startDate: '',
      //   结束时间
      endDate: '',
      //   类别数据
      typeArr: [],
      //   选择类别项
      chooseType: '0',
      pageNum: 0,
      pageSize: 10,
      listCount: 0,
      minDate: null,
      maxDate: null,
    }
  },
  props: {
    //   按钮
    showBtn: {
      type: Boolean,
      default: false
    },
    // 搜索框
    showSearch: {
      type: Boolean,
      default: true
    },
    url: {
      type: String,
      default: 'teas/mobile/logistic/dined/personnel/getDinedPersonnelList'
    }
  },
  created() {
    if (this.isDesign) {
      this.list.push({
        category: null,
        dept_text: "教务处",
        dept_value: "1260401216ec400a9349395d6a61fbde",
        dined_time: "2022-04-22",
        ds_create_user_id: "f0e95fa2c5a44a92916f625a6e9a21f4",
        ds_create_user_name: "钟鹏飞",
        num: "20",
        reason: "22",
        restaurant: null,
        s_cur_link_id: null,
        s_pid: null,
        status_text: "未申请",
        status_value: "0",
        _id: "bde1d7dd382e46fbb0d4ac75d07a50a4"
      })
    } else {
      let now = new Date();
      let year = now.getFullYear();
      let mon = now.getMonth() + 1;
      let day = now.getDate();
      this.minDate = new Date(year - 10, mon, day);
      this.maxDate = new Date(year + 10, mon, day);
      this.getType()
      this.getList()
    }

  },
  activated() {
    this.list = [];
    this.pageNum = 0;
    this.refreshing = false;
    this.finished = false;
    this.getList();
  },
  methods: {
    search() {
      this.pageNum = 0;
      this.list = [];
      this.getList()
    },
    addBtn() {
      this.$emit('add')
    },
    pickerCz() {
      this.startDate = "";
      this.endDate = "";
      this.chooseType = "0";

    },
    pickerSure() {
      this.showPicker = false;
      this.pageNum = 0;
      this.refreshing = false;
      this.finished = false;
      this.list = [];
      this.getList()
    },
    listClick(item, index) {
      this.$emit('click', { item, index })
    },
    getStatus(val) {
      if (val == '0') {
        return 'info'
      } else if (val == '1') {
        return 'warning'
      } else if (val == '2') {
        return 'danger'
      } else if (val == '3') {
        return 'success'
      } else if (val == '4') {
        return 'danger'
      }
    },
    // 获取列表数据
    getList(isRefresh = false) {
      if(this.isDesign){
        this.finished=true;
        return
      }
      this.pageNum++;
      let data = {
        userId: null,
        startDate: this.startDate,
        endDate: this.endDate,
        category: this.chooseType == '0' ? '' : this.chooseType,
        searchValue: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.queryString.audit) {
        data.audit = this.queryString.audit
      }
      this.$http.get(this.url, data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          if (isRefresh) {
            this.list = res.data.list
          } else {
            this.list.push(...res.data.list);
          }
          this.listCount = res.data.count;
          if (this.listCount == this.list.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          dsf.layer.message(res.message, false);
          this.error = true;
          this.finished = true;
        }
      })
        .error((err) => {
          this.error = true;
          this.finished = true;
          dsf.layer.message(err.message || "出错了，请重试", false);
        }).always(() => {
          this.loading = false;
          this.refreshing = false
        })
    },
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
    },
    onSearch() {
      this.showPicker = true
    },
    onConfirm(data) {
      this.startDate = this.getTime(data[0])
      this.endDate = this.getTime(data[1])
      this.showDate = false;
    },
    chooseChange(val) {
      this.chooseType = val.value;
    },
    getTime(val) {
      let date = new Date(val);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate() + ' ';
      // let  h = date.getHours() + ':';
      //  let m = date.getMinutes() + ':';
      //  let s = date.getSeconds();
      //  return Y + M + D + h + m + s
      return Y + M + D
    },
    getType() {
      let data = {
        pageName: 'edit',
        namespace: 'teas.logistics.dined.personnel'
      }
      this.$http.get('meta/init', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.typeArr = res.data['teas_logistics_dined_personnel_detail.category'].dataSource;
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    }
  },
})
</script>

<style>
</style>